import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import { ActionsColumn, IdColumn, SubTypeColumn, TypeColumn } from './columns';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { DateTimeColumn, MultiSelectCreatable } from '../../../common';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import FilterTopToolbar from '../../../common/tables/toolbars/FilterTopToolbar';
import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import JsonOptionsColumn from '../../../common/tables/columns/JsonOptionsColumn';
import { MantineReactTable } from 'mantine-react-table';
import { getSystemEvents } from '../../../../http/apiClient';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const SystemEventsView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [activeFilters, setActiveFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    });

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getSystemEvents(queryParams),
        queryKey: ['system_events'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const { data: systemEvents, pagination: dataPagination } =
        paginatedData || {};
    const columns = useMemo(
        () => [
            IdColumn(),
            TypeColumn(),
            SubTypeColumn(),
            JsonOptionsColumn({
                header: 'Event Data',
                accessorKey: 'eventData',
            }),
            DateTimeColumn({
                id: 'at',
                header: 'At',
                accessorFn: (rowData) => rowData.at,
                format: 'L LTS',
            }),
        ],
        [systemEvents]
    );

    /*const tableData = useMemo(
        () => (isLoading ? [] : campaigns),
        [campaigns, isLoading]
    );*/

    const tableData = useMemo(
        () => (isLoading ? [] : systemEvents),
        [systemEvents, isLoading]
    );

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'system-events-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'system-events-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: true,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Events',
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },
        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: ({ ...props }) => (
            <FilterTopToolbar
                activeFilters={activeFilters}
                filterOptions={[]}
                onFilterChange={setActiveFilters}
            />
        ),
        renderRowActions: ActionsColumn,

        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
        </Container>
    );
};
export default SystemEventsView;
